import forge from 'node-forge';
import { RSA_PUBLIC_KEY } from './config';

// GET
export const encryptMessage = (message) => {
  const publicKeyPem = RSA_PUBLIC_KEY;
  const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);
  const encrypted = publicKey.encrypt(message, 'RSA-OAEP');
  return forge.util.encode64(encrypted);
};

// Hàm để tạo một khóa AES ngẫu nhiên
const generateAESKey = () => {
  return forge.random.getBytesSync(32); // 32 bytes = 256 bits
}

// Hàm để mã hóa dữ liệu bằng AES
const encryptDataWithAES = (data, key) => {
  const iv = forge.random.getBytesSync(16); // Initialization vector
  const cipher = forge.cipher.createCipher('AES-CBC', key);
  cipher.start({ iv: iv });
  cipher.update(forge.util.createBuffer(data, 'utf8'));
  cipher.finish();
  return {
    iv: forge.util.encode64(iv),
    encryptedData: forge.util.encode64(cipher.output.getBytes())
  };
}

// Hàm để mã hóa khóa AES bằng RSA OAEP
const encryptAESKeyWithRSA = (aesKey, publicKey) => {
  const rsa = forge.pki.publicKeyFromPem(publicKey);
  const encryptedAESKey = rsa.encrypt(aesKey, 'RSA-OAEP', {
    md: forge.md.sha256.create()
  });
  return forge.util.encode64(encryptedAESKey);
}

// POST
export const encryptLargeData = (data) => {
  const publicKeyPem = RSA_PUBLIC_KEY;
  const aesKey = generateAESKey();
  const encryptedData = encryptDataWithAES(data, aesKey);
  const encryptedAESKey = encryptAESKeyWithRSA(aesKey, publicKeyPem);

  return {
    encryptedAESKey: encryptedAESKey,
    iv: encryptedData.iv,
    encryptedData: encryptedData.encryptedData
  };
}